import { Card } from "../../../../components/Card";
import { Skeleton } from "../../../../components/Skeleton";

export function CertificationCardListSkeleton() {
    return (
        <Card className="flex-1 !px-0">
            <div className="flex items-center justify-between px-6 mb-6">
                <div className="flex flex-col gap-1.5">
                    <Skeleton className="w-48 h-4" />
                    <Skeleton className="w-24 h-4" />
                </div>
                <Skeleton className="w-32 h-8" />
            </div>
            {
                [1,2,3,4,5,6].map((item: any) => (
                    <div key={item} className="flex flex-col gap-2 px-4">
                        <div className="flex gap-6 items-center rounded-[6px] px-2 py-2.5 justify-between">
                            <div className="flex flex-col gap-2">
                                <Skeleton className="w-48 h-4" />
                                <Skeleton className="w-24 h-4" />
                            </div>
                            <div className="flex-1 flex flex-col gap-2 min-w-[175px] max-w-[275px]">
                                <Skeleton className="w-full h-2.5" />
                                <div className="flex items-center gap-1 justify-between">
                                    {
                                        [1,2,3,4,5].map((count: any) => (
                                            <div className="flex items-center gap-1 flex-col" key={count}>
                                                <Skeleton className="w-3.5 h-3" />
                                                <Skeleton className="w-12 h-3" />
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="border-b-[0.5px] border-b-[#DADADA]" />
                    </div>
                ))
            }
        </Card>
    );
}